import {useMutation} from "react-query";
import {CreateGroupCommand} from "../../models/group";
import groupService from "../../services/GroupService";

export default function useCreateGroup() {
   return useMutation((request: CreateGroupCommand) => groupService.create(request));
}